import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const viewDoctorSignupRequestApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor-signup-request/${params.id}`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default viewDoctorSignupRequestApi